import {useIntl} from 'react-intl'

export default function useGiftCardFields({
    form: {
        control,
        formState: {errors}
    },
    prefix = ''
}) {
    const {formatMessage} = useIntl()

    const fields = {
        cardNumber: {
            name: `${prefix}cardNumber`,
            placeholder: formatMessage({
                id: 'gift_card_form.card_number.placeholder',
                defaultMessage: 'Card Number (19 digits)*'
            }),
            type: 'text',
            rules: {
                required: formatMessage({
                    id: 'gift_card_form.card_number.required',
                    defaultMessage: 'Card number is required'
                }),
                pattern: {
                    value: /^\d{19}$/,
                    message: formatMessage({
                        id: 'gift_card_form.card_number.pattern',
                        defaultMessage: 'Card number must be exactly 19 digits'
                    })
                }
            },
            error: errors[`${prefix}cardNumber`],
            control,
            inputProps: {
                paddingRight: 0,
                maxLength: 19
            },
            autoComplete: 'off'
        },

        pin: {
            name: `${prefix}pin`,
            placeholder: formatMessage({
                id: 'gift_card_form.pin.placeholder',
                defaultMessage: 'PIN*'
            }),
            type: 'password',
            rules: {
                required: formatMessage({
                    id: 'gift_card_form.pin.required',
                    defaultMessage: 'PIN is required'
                })
            },
            error: errors[`${prefix}pin`],
            control,
            inputProps: {
                paddingRight: 0
            },
            showPasswordToggle: false,
            autoComplete: 'new-password'
        }
    }

    return fields
}